import React from "react";
import PRIVACY_POLICY_HTML from "./PrivacyPolicyHtml";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-wrapper">
        <div
          className="privacy-container"
          dangerouslySetInnerHTML={{ __html: PRIVACY_POLICY_HTML }}
        />
      </div>
    </div>
  );
}

